/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2022 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import {FETCH_OFFER_DETAILS_SUCCESS,UPDATE_OFFER_END_DATE} from "../_actions/etext.publish.actions";

export const INITIAL_STATE = {
    offerDetails :{},
    offerChangeDetails:{}
};

export function offerDetailsReducer (state = INITIAL_STATE, action) {
    switch (action.type) {
        case FETCH_OFFER_DETAILS_SUCCESS:{
            return {...state, offerDetails:action.payload, offerChangeDetails:{}};
        }
        case UPDATE_OFFER_END_DATE: {
            let copyOfferEndDate = state.offerDetails && state.offerDetails._embedded && state.offerDetails._embedded.offers.map(offers => { return { ...offers }; });
            copyOfferEndDate[action.payload.index].offerEndDate = action.payload.offerEndDate;
            return {
                ...state, offerDetails: { ...state.offerDetails, _embedded: { offers: copyOfferEndDate } },
                offerChangeDetails: { ...state.offerChangeDetails, [action.payload.offerId]: { offerEndDate: action.payload.offerEndDate } }
            };
        }
        default: {
            return state;
        }
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/offer.details.reducer.js